import React, { useEffect } from "react";
import Routers from "./layout/Routers";
import { UserProvider } from "./util/Context";
import { CartProvider } from "./util/CartContext";
import { CustomerProvider } from "./util/CustomerContext";
import "./App.css";

function App() {
  useEffect(() => {
    fetch("https://treacy-0e0969b170ac.herokuapp.com/").catch(() => {});
  }, []);

  return (
    <div className="">
      <UserProvider>
        <CartProvider>
          <CustomerProvider>
            <Routers />
          </CustomerProvider>
        </CartProvider>
      </UserProvider>
    </div>
  );
}

export default App;
